import TodaysActions from '../pages/TodaysActions';

// Admin-owned intake buckets are hidden on per-clinic tabs — those are handled
// centrally by the admin team, not by Office Directors on the clinic pages.
// New Online Inquiries is intake-triage owned by Admin, so it's also hidden
// from the per-clinic tabs (iter 63 request).
const HIDDEN_ON_CLINIC_TAB = [
  'new_online_inquiries',
  'new_referrals',
  'paperwork_overdue',
  'paperwork_pending',
  'paperwork_followup',
  'paperwork_stalled',
  'ready_for_eval',
];

export default function ClinicToday({ clinicName }) {
  if (!clinicName) return null;
  return <TodaysActions scopedClinic={clinicName} hideSectionKeys={HIDDEN_ON_CLINIC_TAB} />;
}
